import { TerminalReplay } from "../terminal-replay";
import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptStep, ConceptText } from "./components";

type ExecutionOrderContent = Extract<
  ConceptContentData,
  { slug: "execution-order" }
>;

export function ExecutionOrderConcept({
  content,
}: {
  content: ExecutionOrderContent;
}) {
  return (
    <div className="grid gap-8">
      <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)]">
        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />

        <ol className="grid gap-5">
          {content.steps.map((step, index) => (
            <ConceptStep key={step} number={String(index + 1)}>
              <ConceptText text={step} />
            </ConceptStep>
          ))}
        </ol>
      </div>

      <TerminalReplay
        context={content.terminalReplay.context}
        steps={content.terminalReplay.steps}
        title={content.terminalReplay.title}
      />
    </div>
  );
}
